import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const reviewsAPI = createApi({
    reducerPath: "reviewsAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllOrderReviews: builder.query({
            query: ({ page, size }) => {
                let apiUrl = `admin/order-review?page=${page}&limit=${size}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["reviews"],
        })
    })
});

export const { 
    useGetAllOrderReviewsQuery
} = reviewsAPI;

export default reviewsAPI;